import 'leaflet'
import MapPopup                               from './popup/MapPopup.js'
import MapPopupTko                            from './popup/MapPopupTko.js'
import MapPopupCity                           from './popup/MapPopupCity.js'
import MapPopupRelation                       from './popup/MapPopupRelation.js'
import MapPopupCar                            from './popup/MapPopupCar'
import { OBJECT }                             from './types.js'
import { POPUP_AUTO_PAN, POPUP_KEEP_IN_VIEW } from '../../config/map.js'
import MapPopupOffline                        from './popup/MapPopupOffline'
import MapEquidistant                         from './popup/MapEquidistant.js'

class PopupCreator {
  
  defaultOptions = {
    autoPan:         POPUP_AUTO_PAN,
    keepInView:      POPUP_KEEP_IN_VIEW,
    maxHeight:       400,
    maxWidth:        600,
    opts:            {},
    model:           null,
    id:              null,
    openedPopupInfo: null,
    layerConfig:     null,
    subLayerConfig:  null
  }
  
  vm = null
  
  constructor(vm = {}) {
    this.vm                     = vm
    this.defaultOptions.opts.vm = vm
  }
  
  getTkoPopup(options = null) {
    return new MapPopupTko(options)
  }
  
  getCityPopup(options = null) {
    return new MapPopupCity(options)
  }
  
  getRelationPopup(options = null) {
    return new MapPopupRelation(options)
  }
  
  getObjectPopup(options = null) {
    return new MapPopup(options)
  }
  
  getCarPopup(options = null) {
    return new MapPopupCar(options)
  }
  
  getOfflinePopup(options = null) {
    return new MapPopupOffline(options)
  }
  
  getEquidistantPopup(options = null) {
    return new MapEquidistant(options)
  }
  
  getPopup(marker, type = 'default', popupId = null, options = {}) {
    options                 = Object.assign(this.defaultOptions, options)
    options.model           = marker.options.model || marker.model || {}
    options.id              = options.model.id || options.id || null
    options.openedPopupInfo = popupId
    options.layerConfig     = marker.options.layerConfig || options.layerConfig || null
    options.subLayerConfig  = marker.options.subLayerConfig || options.subLayerConfig || null
    
    if (options.autoPan && !options.autoPanPaddingTopLeft) {
      options.autoPanPaddingTopLeft = L.point(150, 150)
    }
    
    if (type === OBJECT.TKO) {
      return options.subLayerConfig ? this.getObjectPopup(options) : this.getTkoPopup(options)
    } else if (type === OBJECT.CITY) {
      return this.getCityPopup(options)
    } else if (type === OBJECT.REL) {
      return this.getRelationPopup(Object.assign({ ...options }, { minWidth: 1000, maxHeight: null }))
    } else if (type === OBJECT.CAR) {
      return this.getCarPopup(options)
    } else if (type === OBJECT.OFFLINE) {
      return this.getOfflinePopup(options)
    } else if (type === OBJECT.EQUIDISTANT) {
      return this.getEquidistantPopup(options)
    }
    
    return this.getObjectPopup(options)
  }
}

export default PopupCreator
